<template>
    <div>
        <div v-if="activeAccount && activeAccount.consents && activeAccount.consents.length > 0" class="pa-5">
            <div v-for="item in activeAccount.consents" :key="`consent_${item.id}`">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.status ? item.status : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Consent valid until" | t }}</v-col>
                    <v-col class="col-item font-weight-bold" cols="9" :style="{ 'color': getConsentValidUntilColor(calculateDays(tz(item.consent_valid_until)))}">
                        {{ item.consent_valid_until ? `${tz(item.consent_valid_until)} (${calculateDays(tz(item.consent_valid_until))} days left)` : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Consent type" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.consent_type ? item.consent_type : "-" }}
                    </v-col>
                </v-row>
                <v-divider class="mb-6 mt-6"/>
            </div>
        </div>
        <div v-else class="pa-5 text-center">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";

export default {
    name: "consent-account-consents-tab",
    computed: {
        ...mapState('ais', ['activeAccount']),
    },
    methods: {
        calculateDays(date) {
            let todayDate = moment(new Date());
            let given = moment(date);
            return (given.diff(todayDate, "days"));
        },
        getConsentValidUntilColor(days) {
            if (days > 10) {
                return 'green'
            } else if (days <= 10 && days >= 4) {
                return '#E0C02B'
            } else {
                return 'red'
            }
        }
    }
}
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>